(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.shopify-section');
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
      this.compact = false;
      this.onScrollHandler = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.observer = new ResizeObserver(() => this.setHeaderHeight());
      this.observer.observe(this.header);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.update();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
    }
    update() {
      const y = Math.max(0, window.scrollY);
      // Separate thresholds prevent the shorter header from toggling repeatedly.
      const drawerOpen = this.header.querySelector('header-drawer > details[open]');
      const next = drawerOpen ? this.compact : (this.compact ? y > 10 : y > 220);
      if (next !== this.compact) {
        if (next) {
          this.header.querySelectorAll('header-menu').forEach(menu => menu.close?.());
        }
        this.compact = next;
        this.header.classList.toggle('pp-header-compact', next);
      }
      this.setHeaderHeight();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  }
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
